module.exports = __webpack_public_path__ + "static/media/slide-curs-adaptare.d2cd7244.png";